import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Icon from 'components/shared/Icon';

import back from 'images/back.svg';

interface BackProps {
  linkBackTo: string;
}

const BackText = styled.div`
  font-family: 'CircularStd-Medium';
  font-size: 15px;
  color: #1d4ed8;
`;

const BackContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const Back: React.FC<BackProps> = ({ linkBackTo }) => {
  return (
    <Link to={linkBackTo}>
      <BackContainer>
        <Icon src={back} />
        <BackText>Go back</BackText>
      </BackContainer>
    </Link>
  );
};

export default Back;
